import {_EventTypeGeneric as EventType} from './eventType.generic'

// eslint-disable-next-line sonarjs/class-name
export class _EventHelpGeneric {
  static base() {
    return [
      EventType.MORTALITY,
      EventType.MORTALITY_IMPLANT,
      EventType.PROXIMITY,
      EventType.SEPARATION,
      EventType.TRAP,
      EventType.VAGINAL_IMPLANT,
      EventType.VIRTUAL_FENCE,
      EventType.ACTIVITY,
      EventType.COLLAR_LOG,
    ] as const
  }

  static all() {
    return [...this.base(), EventType.POSITION] as const
  }

  static toOpenApiTag(target: EventType, isGPS?: boolean, isLogEvents?: boolean) {
    switch (target) {
      case EventType.POSITION:
        return isGPS ? 'GPSPositions' : 'Positions'
      case EventType.TRAP:
        return 'TrapEvents'
      case EventType.MORTALITY:
        return 'Mortalities'
      case EventType.PROXIMITY:
        return 'Proximities'
      case EventType.ACTIVITY:
        return 'Activities'
      case EventType.VIRTUAL_FENCE:
        return 'VirtualFenceEvents'
      case EventType.COLLAR_LOG:
        return isLogEvents ? 'CollarLogEvents' : 'CollarLogs'
      default:
        return `${target}s`
    }
  }
}
